module.exports = __webpack_public_path__ + "static/media/top-img_7a_mob.9f3b57fa.png";